export default (t) => [
  {
    text: t('Reservation Code'),
    value: 'code',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('Customer Name'),
    value: 'customer_name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Telephone'),
    value: 'telephone',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('Table'),
    value: 'table',
    sortable: false,
    width: 110,
    togglable: true
  },
  {
    text: t('Guests'),
    value: 'guests',
    sortable: false,
    width: 90,
    togglable: true
  },
  {
    text: t('Reservation Date'),
    value: 'reservation_at',
    sortable: true,
    width: 170,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'state',
    sortable: false,
    width: 110,
    togglable: true
  },
  {
    text: t('Note'),
    value: 'note',
    sortable: false,
    width: 180,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
